/* This is generated code, don't alter */
var IfcWindowStyleConstructionEnum;
(function (IfcWindowStyleConstructionEnum) {
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["ALUMINIUM"] = 0] = "ALUMINIUM";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["HIGH_GRADE_STEEL"] = 1] = "HIGH_GRADE_STEEL";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["STEEL"] = 2] = "STEEL";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["WOOD"] = 3] = "WOOD";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["ALUMINIUM_WOOD"] = 4] = "ALUMINIUM_WOOD";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["PLASTIC"] = 5] = "PLASTIC";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["OTHER_CONSTRUCTION"] = 6] = "OTHER_CONSTRUCTION";
    IfcWindowStyleConstructionEnum[IfcWindowStyleConstructionEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcWindowStyleConstructionEnum || (IfcWindowStyleConstructionEnum = {}));
const IfcWindowStyleConstructionEnumCount = 8;
export { IfcWindowStyleConstructionEnum, IfcWindowStyleConstructionEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcWindowStyleConstructionEnum = new Int32Array([16, -2, 2]);
let prefixSumAddressIfcWindowStyleConstructionEnum = new Uint32Array([0, 12, 23, 32, 48, 55, 75, 93, 99]);
let slotMapIfcWindowStyleConstructionEnum = new Int32Array([7, 0, 5, 4, 2, 6, 1, 3]);
let encodedDataIfcWindowStyleConstructionEnum = (new TextEncoder()).encode(".NOTDEFINED..ALUMINIUM..PLASTIC..ALUMINIUM_WOOD..STEEL..OTHER_CONSTRUCTION..HIGH_GRADE_STEEL..WOOD.");
let IfcWindowStyleConstructionEnumSearch = new MinimalPerfectHash(gMapIfcWindowStyleConstructionEnum, prefixSumAddressIfcWindowStyleConstructionEnum, slotMapIfcWindowStyleConstructionEnum, encodedDataIfcWindowStyleConstructionEnum);
export { IfcWindowStyleConstructionEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcWindowStyleConstructionEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcWindowStyleConstructionEnumSearch, input, cursor, endCursor);
}
